




















































































































































































import _ from 'lodash';
import dayjs from 'dayjs';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { editFactory } from '@/main/pages';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { PROrders } from '@/modules/sklad/PROrders';
import { EventBus } from '@/main/eventBus';
import { Dealer } from '@/modules/sklad/dealer';
import { NdObjednavka } from '@/modules/sklad/ndObjednavka';
import { showAlert } from '@/main/utils/notifications';
import { formatDecimalValue } from '@/main/utils/stringHelper';
import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import {
	Cell,
	getColumnsRowMapObject,
	Row,
	EditableStatus, convertToObjects,
} from '@/main/utils/table';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import { editMutations } from './store/types';
import buttons from './components/Buttons.vue';
import { NdPrijemkaPolozky } from './polozky';
import { DEPENDENT_TABLES, DOKLADY, NAME, EDL_NDPRIJEM_PZN, NDPRIJEMKA_PZN ,NDPRIJEMKA_STATUS, PR_ORDER, HideColumns, GRID_COLUMNS } from './constants';
import { store } from './store/edit';
import { apiProvider as ndPrijemkaApiProvider, apiProvider } from './api';

import { apiProvider as apiPolozkyProvider } from './polozky/api';
import { TABLE_DATA, START_LOADING, END_LOADING } from '@/main/store/listEditTypes';

export default editFactory(NAME, store).extend({
	components: {
		DodavatelSelect: Dodavatel.components.Select,
		PrordersSelect: PROrders.components.Select,
		NdObjednavkaSelect: NdObjednavka.components.Select,
		DealerSelect: Dealer.components.Select,
		buttons,
		DmsEditableTable,
	},
	data() {
		return {
			dependencies: {
				...DEPENDENT_TABLES,
			},
			ndprijemkaPznEnum: NDPRIJEMKA_PZN,
			pickerOptions: { disabledDate(time:Date) { return time.getTime() < dayjs().date() - dayjs().millisecond(); } },
			isPartPurchaseOrderDisplay: false,
			multipleSelection: [],
			searchKey: null,
			gridCols: GRID_COLUMNS,
		};
	},
	watch: {		
		NdprijemPzn(newVal) {
			if (this.loggedUser.DmsSys.PROrdersPrp) {
				this.NcCelkPrp = false;
				return;
			}
			this.NcCelkPrp = newVal === NDPRIJEMKA_PZN.PRIJEM_PREVOD;
		},
		polozkyCount(val) {
			if (val) {
				(this.$refs.polozky as any).refreshLayout();
			}
		},
		Discount(newValue) {
			this.DiscAfterCalc = ((this.TotalPrice ?? 0) * newValue!) / 100;
			this.PriceAfterDisc = this.TotalPrice! - this.DiscAfterCalc!;
			if (this.dmsSys.EnableGSTPrp) {
				this.TotalPriceAfterDiscWithGst = this.PriceAfterDisc! + this.GstAmt!;
			}
			if (this.dmsSys.EnableVATPrp) {
				this.TotalPriceAfterDiscWithVat = this.PriceAfterDisc! + this.VatAmt!;
			}
		},
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		PurchaseOrder(): any {
			_.forEach(this.dependentTables.PROrders.columns, (col) => {
				if (col.columnName.toUpperCase() === HideColumns.SUPPLIER_ID
					|| col.columnName.toUpperCase() === HideColumns.PART_NO
					|| col.columnName.toUpperCase() === HideColumns.STATUS_ID
					|| col.columnName.toUpperCase() === HideColumns.PR_DOC_NO
					|| col.columnName.toUpperCase() === HideColumns.WAREHOUSE_ID
					|| col.columnName.toUpperCase() === HideColumns.ORDER_NO
					|| col.columnName.toUpperCase() === HideColumns.IS_DEALER
					|| col.columnName.toUpperCase() === HideColumns.BILL_TO_WAREHOUSE_ID) {
					col.isVisible = false;
				}
			});
			return this.dependentTables.PROrders;
		},
		disableUzavreni(): boolean {
			return this.Status! > NDPRIJEMKA_STATUS.UZAV_KE_KOREKCI || this.isViewMode;
		},
		mutationsMappers(): Record<string, string> {
			return {
				dodavatel: `${this.storeUri}/${editMutations.ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER}`,
				prorders: `${this.storeUri}/${editMutations.ND_PRIJEMKA_PRORDERS_SELECT_MAPPER}`,
				dealer: `${this.storeUri}/${editMutations.ND_PRIJEMKA_DEALER_SELECT_MAPPER}`,
			};
		},
		selectSupplierFilter() : object {
			return{
				SupplierId : this.DodavatelId,
			}
		},
		dokladyName(): string {
			return DOKLADY;
		},
		polozkyCount(): number {
			return this.dependentTables.NdPrijemkaPolozky.rows.length;
		},
		ndPrijemkaPolozkyName(): string {
			return NdPrijemkaPolozky.name;
		},
		isEdelPrijemka(): boolean {
			return EDL_NDPRIJEM_PZN.includes(this.NdprijemPzn!);
		},
		isZpracujMode(): boolean {
			return this.props.isZpracujMode;
		},
		isUzavren(): boolean {
			return !_.isNil(this.UzavreniDat);
		},
		allowDelete(): boolean {
			return !this.isUzavren;
		},
		allowSave(): boolean {
			return !this.isUzavren;
		},
		isSkladDisabled(): boolean {
			return (this.PrOrderId! > 0) || (this.isEdelPrijemka && !this.isCreateMode) || this.isUzavren || this.isViewMode || this.DodListNr != null;
		},
		showRefresh(): boolean {
			return this.PrOrderId! > 0;
		},
		formattedTotalPrice(): string | null {
			return this.TotalPrice != null ? formatDecimalValue(this.TotalPrice) : this.TotalPrice;
		},
		formattedTotalPriceAfterDiscWithGst(): string | null {
			return this.TotalPriceAfterDiscWithGst != null ? formatDecimalValue(this.TotalPriceAfterDiscWithGst) : this.TotalPriceAfterDiscWithGst;
		},
		formattedVatAmt(): string | null {
			return this.VatAmt != null ? formatDecimalValue(this.VatAmt) : this.VatAmt;
		},
		enabledDelete(): boolean {
			if(this.NdprijemPzn === NDPRIJEMKA_PZN.PRIJEM_PREVOD) {
				return false;
			}
			return true;
		},
	},
	mounted() {
		if (this.isZpracujMode) {
			EventBus.$emit('DisableAll', true);
		}
	},
	methods: {
		onCellClick({ row }: { row: Row }) {
			OpenPartMaintenance({ cellNames: this.dependentTables.NdPrijemkaPolozky.cellNames, row });
		},
		canEditRow(row: Row) {
			return !this.disableUzavreni;
		},		
		async refreshTable(name: string) {
			await this.fetchTableData([name]);
		},
		refreshFun() {
			this.fetchTableData();
		},
		async loadedData() {
			this.mainCollapse.push(NdPrijemkaPolozky.name);
			this.mainCollapse.push(DOKLADY, NdPrijemkaPolozky.name);
		},
		discountCalculation() {
			this.DiscAfterCalc = ((this.TotalPrice ?? 0) * this.Discount!) / 100;
			this.PriceAfterDisc = this.TotalPrice! - this.DiscAfterCalc!;
		},
		async createPolozku() {
			const { data: totalCount } = await apiProvider.getTotalCount(this.PrijemkaId!);
			openEdit(NdPrijemkaPolozky.name, PageMode.CREATE,
				{
					props: true,
					filter: { prijemkaId: this.entityId },
					SkladOzn: this.SkladOzn,
					ncCelkPrpActual: this.NcCelkPrp,
					MioId: this.MioId,
					MioNdNr: this.MioNDNr,
					Quantity: this.Quantity,
					VyrobekndOzn: this.VyrobekndOzn,
					TotalMnozstvi: totalCount,
				});
		},
		async refreshPolozky() {
			if (this.isCreateMode && this.PrOrderId! > 0) {
				const result = await this.save(false);
				if (result instanceof Error) return;
				await ndPrijemkaApiProvider.savePrReceiptItems(this.edit);
				await this.refreshTable(NdPrijemkaPolozky.name);
				await this.changeToEdit(this.PrijemkaId);
				if (!this.mainCollapse.includes(NdPrijemkaPolozky.name)) {
					this.mainCollapse.push(NdPrijemkaPolozky.name);
				}
			} else {
				this.startLoading();
				const { data: isDataSaved } = await ndPrijemkaApiProvider.savePrReceiptItems(this.edit);
				this.endLoading();
				if (isDataSaved) {
					await this.refreshTable(NdPrijemkaPolozky.name);
					await this.changeToEdit(this.PrijemkaId);
					if (!this.mainCollapse.includes(NdPrijemkaPolozky.name)) {
						this.mainCollapse.push(NdPrijemkaPolozky.name);
					}
				} else {
					showAlert({
						message: this.LocalizeChyboveHlasky('PO_EXIST'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
				 	});
				}
			}
		},
	    partsValidation() {
            const parts = convertToObjects(this.dependentTables.NdPrijemkaPolozky);
               for (let i = 0; i < parts.length; i++) {
                  const partInfo = parts[i];
                    if (partInfo.UnitCostPrice === null || partInfo.UnitCostPrice <= 0 || partInfo.ReceiptQuantity === null || partInfo.ReceiptQuantity <= 0) {
                        this.showErrorAlert({
                        message: this.LocalizeChyboveHlasky('RECEIPTQTY_UNITCOST_GREATER_THAN_ZERO'),
                        options: { type: 'error' },
                        localizeMessage: false,
                    });
                return false;
            }
        }
        return true;
    },
		async saveClick() {
		if (!this.partsValidation()) return;
		  const part = convertToObjects(this.dependentTables.NdPrijemkaPolozky).map((partInfo, idx) => {
				if (partInfo.ZaznamId < 0) {
					partInfo.ZaznamId = null;
				}
				return ({ ...partInfo });
			});

		  this.edit = {
				...this.edit,
		    NdPrijemkaPolozky: part,
		 };
		 console.log(this.edit);
		 await apiProvider.saveGrnItems(part, this.PrijemkaId);
		 await this.save(false);
		 await this.entity();
		 this.fetchTableData();
			(this.$refs.table as any).refreshLayout();
		},
		async createPrijemPolozClick() {
			if (this.isCreateMode) {
				const result = await this.save(false);
				if (result instanceof Error) return;
				await this.changeToEdit(this.PrijemkaId);
			}

			this.createPolozku();
		},
		openEditPolozka(event: any) {
			openEdit(NdPrijemkaPolozky.name, PageMode.EDIT, { props: true, id: event.data.ZAZNAM_ID, ncCelkPrpActual: this.NcCelkPrp });
		},

		refreshDoklady() {
			this.refreshTable(DOKLADY);
			if (!this.mainCollapse.includes(DOKLADY)) {
				this.mainCollapse.push(DOKLADY);
			}
		},
		async deletePRItem({ data }: { data: { ID: number } }) {
			await apiProvider.updateNdPrijemkaAfterDelete(data.ID);
			await apiPolozkyProvider.deleteEntity(data.ID);

			await this.refreshTable(NdPrijemkaPolozky.name);
			if (!this.mainCollapse.includes(NdPrijemkaPolozky.name)) {
				this.mainCollapse.push(NdPrijemkaPolozky.name);
			}
		},
		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			if(this.NdprijemPzn === NDPRIJEMKA_PZN.PRIJEM_PREVOD) {
				if (this.dependentTables.NdPrijemkaPolozky.columnSettings && this.dependentTables.NdPrijemkaPolozky.columnSettings.RECEIPT_QUANTITY) {
					this.dependentTables.NdPrijemkaPolozky.columnSettings.RECEIPT_QUANTITY.isEditable = false;
				}
				if (this.dependentTables.NdPrijemkaPolozky.columnSettings && this.dependentTables.NdPrijemkaPolozky.columnSettings.TEXT) {
					this.dependentTables.NdPrijemkaPolozky.columnSettings.TEXT.isEditable = false;
				}
				if (this.dependentTables.NdPrijemkaPolozky.columnSettings && this.dependentTables.NdPrijemkaPolozky.columnSettings.DISCOUNT_PCT) {
					this.dependentTables.NdPrijemkaPolozky.columnSettings.DISCOUNT_PCT.isEditable = false;
				}
			}
		 },
		rowSaved({ row: newRow }: { row: Row },) {		
		 const receiptQuantityIndex: number = this.dependentTables.NdPrijemkaPolozky.cellNames!.RECEIPT_QUANTITY;
		 const remainingPartQuantityIndex:number = this.dependentTables.NdPrijemkaPolozky.cellNames!.LEFT_PART_QUANTITY;
		 const receiptQuantity = Number(newRow.cells[receiptQuantityIndex]);
		 const remainingQuantity = Number(newRow.cells[remainingPartQuantityIndex]);

		 if (receiptQuantity > remainingQuantity) {
			newRow.cells[receiptQuantityIndex] = remainingQuantity;
			this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('ReceiptQuantityShouldBeLessThanOrEqualToRemainingPartQuantity'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
		 }
		},
		rowCancel(row: any) {

		},
		handleSelection(rows: []) {			
			this.multipleSelection = rows;
		},
		async isPartLocked() {
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await this.fetchTableData([PR_ORDER]);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			this.isPartPurchaseOrderDisplay = true;
		},
		async refreshProrders() {
			this.searchKey = null;
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await this.fetchTableData([PR_ORDER]);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
		search() {
			if(this.searchKey !== null) {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				this.$store.dispatch(`${this.storeUri}/${PR_ORDER}_${TABLE_DATA}`, { filter: { PrOrderId: this.searchKey } });
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}

		},
		checkDiff(selectedarray: any) {
			const check =  selectedarray.length !== 0 && new Set(selectedarray).size !== 1;
			return check;
		},
		
		async getSelectedParts() {
			this.isPartPurchaseOrderDisplay = false;
			const idColumnIndex = this.dependentTables.PROrders!.cellNames!.idColumn;
			const checkboxColumnIndex = this.dependentTables.PROrders!.cellNames!.CHECKBOX;
			const supplierIdex = this.dependentTables.PROrders!.cellNames!.DODAVATEL_ID;
			const orderTypeIndex = this.dependentTables.PROrders!.cellNames!.ORDER_TYPE;
			const wareHouseIndex = this.dependentTables.PROrders!.cellNames!.WAREHOUSE_ID;
			const shipToWareHouseIndex = this.dependentTables.PROrders!.cellNames!.SHIP_TO_WH;
			const isDealerIndex = this.dependentTables.PROrders!.cellNames!.IS_DEALER;
			const billToWareHouseIndex = this.dependentTables.PROrders!.cellNames!.BILL_TO_WH;
			const billToWareHouseIdIndex = this.dependentTables.PROrders!.cellNames!.BILL_TO_WAREHOUSE_ID;
			const selectedValues = this.multipleSelection;
			const supplierId = 	this.multipleSelection.map((s: any) => s.cells[supplierIdex]);
			const orderType = 	this.multipleSelection.map((s: any) => s.cells[orderTypeIndex]);
			const orderId = this.multipleSelection.map((s: any) => s.cells[idColumnIndex]);
			const wareHouse = this.multipleSelection.map((s: any) => s.cells[wareHouseIndex]);
			const isDealer = this.multipleSelection.map((s: any) => s.cells[isDealerIndex]);
			const billToWareHouse = this.multipleSelection.map((s: any) => s.cells[billToWareHouseIndex]);
			const billToWareHouseIds = this.multipleSelection.map((s: any) => s.cells[billToWareHouseIdIndex]);
			const shipToWareHouse = this.multipleSelection.map((s: any) => s.cells[shipToWareHouseIndex]);

			if(this.checkDiff(supplierId)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('UniqueSupplier'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.multipleSelection = [];
				await this.fetchTableData([PR_ORDER]);
				return;
			}
			if(this.checkDiff(orderType)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('UniqueorderType'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.multipleSelection = [];
				await this.fetchTableData([PR_ORDER]);
				return;
			}
			const isDifferentShipToWareHouse = this.checkDiff(wareHouse);
			const isDifferentBillToWareHouse = this.checkDiff(billToWareHouse);
			let infoMessage = '';
			if (isDifferentShipToWareHouse && isDifferentBillToWareHouse) {
				infoMessage = this.LocalizeChyboveHlasky('msgUniqueShipToBillToWareHouse');
			} else if (isDifferentShipToWareHouse) {
				infoMessage = this.LocalizeChyboveHlasky('msgUniqueShipToWareHouse');
			} else if (isDifferentBillToWareHouse) {
				infoMessage = this.LocalizeChyboveHlasky('msgUniqueBillToWareHouse');
			}
			if (infoMessage !== '') {
				showAlert({
					message: infoMessage,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.multipleSelection = [];
				await this.fetchTableData([PR_ORDER]);
				return;
			}
			this.edit.PrOrderId = orderId[NDPRIJEMKA_PZN.PRIJEM_MANUAL];
			this.edit.DodavatelId = supplierId[NDPRIJEMKA_PZN.PRIJEM_MANUAL];
			this.edit.DealerId = supplierId[NDPRIJEMKA_PZN.PRIJEM_MANUAL];
			this.edit.OrderType = orderType[NDPRIJEMKA_PZN.PRIJEM_MANUAL];
			this.edit.IsDealer = isDealer[NDPRIJEMKA_PZN.PRIJEM_MANUAL];
			this.edit.SkladOzn = wareHouse[NDPRIJEMKA_PZN.PRIJEM_MANUAL] !== null ? wareHouse[NDPRIJEMKA_PZN.PRIJEM_MANUAL] : this.SkladOzn;
			this.edit.BillToWareHouseName = billToWareHouse[NDPRIJEMKA_PZN.PRIJEM_MANUAL];
			this.edit.ShipToWareHouseName = shipToWareHouse[NDPRIJEMKA_PZN.PRIJEM_MANUAL];
			this.edit.BillToWarehouseId = billToWareHouseIds[NDPRIJEMKA_PZN.PRIJEM_MANUAL];
			if (selectedValues.length === 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PartsReturn'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.isPartPurchaseOrderDisplay = false;
				return;
			} 
			else {

				const selectedValuesWithIndex = await this.multipleSelection.map((s: any) => s.cells[idColumnIndex]);
				if (this.isCreateMode && this.PrOrderId! > 0) {
					const result = await this.save(false);
					if (result instanceof Error) return;
					this.edit = {
							...this.edit,
							PROrderIds: selectedValuesWithIndex,
					};
					this.edit.PROrderIds = selectedValuesWithIndex;
					await ndPrijemkaApiProvider.saveMultiplePRreceipt(this.edit);
					this.isPartPurchaseOrderDisplay = false;
					await this.refreshTable(NdPrijemkaPolozky.name);
					await this.changeToEdit(this.PrijemkaId);
					if (!this.mainCollapse.includes(NdPrijemkaPolozky.name)) {
						this.mainCollapse.push(NdPrijemkaPolozky.name);
					}
				} else {
					this.startLoading();
					this.edit.PROrderIds = selectedValuesWithIndex;
					const { data: isDataSaved } = await ndPrijemkaApiProvider.saveMultiplePRreceipt(this.edit);
					this.isPartPurchaseOrderDisplay = false;
					this.endLoading();
					if (isDataSaved) {
						await this.refreshTable(NdPrijemkaPolozky.name);
						await this.changeToEdit(this.PrijemkaId);
						if (!this.mainCollapse.includes(NdPrijemkaPolozky.name)) {
							this.mainCollapse.push(NdPrijemkaPolozky.name);
						}
						this.isPartPurchaseOrderDisplay = false;
					} else {
						showAlert({
							message: this.LocalizeChyboveHlasky('PO_EXIST'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						this.isPartPurchaseOrderDisplay = false;
					}
				}
			}
		},

		async deleteClick() {
			this.startLoading();
			const { data: isDeleteEligible } = await apiProvider.isPRReceiptDeleteEligible(this.PrijemkaId);
			this.endLoading();
			if (isDeleteEligible) {
				this.delete(true);
			} else {
				showAlert({
					message: this.LocalizeChyboveHlasky('msgPRReceiptDeleteError'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			}
		},
	},
});
